import React from "react";
import { Link } from "react-router-dom";
import { apiSelisihQty } from "@/lib/api";
import { AlertTriangle } from "lucide-react";
import * as W from "@/lib/waktu";

// Addendum 2 point 1: the owner's quantity-mismatch warning with the details
// (SPK, station, in / result / reject / missing, operator, time) and a direct
// link to the SPK's production history. Warning only: the SPK keeps running.
const waktu = (iso) => (iso ? W.waktu(iso) : "—");

export default function SelisihQty({ onOpen, max = 20, testid = "selisih-qty" }) {
  const [rows, setRows] = React.useState([]);
  React.useEffect(() => { apiSelisihQty().then(setRows).catch(() => setRows([])); }, []);
  const flat = rows.flatMap((s) => s.selisih.map((x, i) => ({ ...x, key: `${s.spk_id}-${i}`, spk_id: s.spk_id, nomor_spk: s.nomor_spk, customer: s.customer })))
    .sort((a, b) => (b.waktu || "").localeCompare(a.waktu || ""));
  if (!flat.length) return null;
  const buka = (x) => (onOpen
    ? <button onClick={() => onOpen(x.spk_id)} className="font-mono text-red-100 underline">{x.nomor_spk}</button>
    : <Link to={`/riwayat-produksi?spk=${x.spk_id}`} className="font-mono text-red-100 underline">{x.nomor_spk}</Link>);
  return (
    <div data-testid={testid} className="rounded-lg border border-red-500/40 bg-red-500/10 p-3 text-sm text-red-200 space-y-2">
      <div className="flex items-center gap-2 font-semibold"><AlertTriangle size={15} /> {flat.length} selisih qty antar pos (barang hilang) di {rows.length} SPK — produksi tetap berjalan</div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead><tr className="text-left text-red-300/80"><th className="pr-3">SPK</th><th className="pr-3">Pos</th><th className="pr-3 text-right">Masuk</th>
            <th className="pr-3 text-right">Hasil</th><th className="pr-3 text-right">Reject</th><th className="pr-3 text-right">Selisih</th><th className="pr-3">Operator</th><th>Waktu</th></tr></thead>
          <tbody>
            {flat.slice(0, max).map((x) => (
              <tr key={x.key} data-testid={`${testid}-row-${x.nomor_spk}`} className="border-t border-red-500/20">
                <td className="pr-3 py-1">{buka(x)}<span className="block text-red-300/70">{x.customer}</span></td>
                <td className="pr-3">{x.pos_nama || x.pos_code}</td>
                <td className="pr-3 text-right font-mono">{x.masuk}</td><td className="pr-3 text-right font-mono">{x.hasil}</td>
                <td className="pr-3 text-right font-mono">{x.reject}</td>
                <td className="pr-3 text-right font-mono font-semibold">{x.selisih ?? x.hilang} {String(x.satuan || "").toLowerCase()}</td>
                <td className="pr-3">{x.operator || "—"}</td><td>{waktu(x.waktu)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {flat.length > max && <div className="text-xs">+{flat.length - max} lainnya di menu Riwayat Produksi</div>}
    </div>
  );
}
